import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "authForm__h1" }
const _hoisted_2 = { class: "authForm__p" }

import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import { defaultProps, validationRules } from './consts';
import NewPasswordOverlays from './ui/NewPasswordOverlays.vue';
import { Alert, EmailSupportButton } from '@/v2/features';
import { LogoTitle, Button, PasswordInput, EmailInput, InputText } from '@/v2/shared/ui';
import { parseGetParams, InvisibleGoogleCaptcha } from '@/v2/shared/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPasswordForm',
  props: defaultProps,
  setup(__props) {

const props = __props;

/** alert */
const alert = ref<InstanceType<typeof Alert>>();
/** captcha */
const captcha = ref<InstanceType<typeof InvisibleGoogleCaptcha>>();
function captchaIsLoading(){
  loading.value = true;
  setTimeout(() => {
    captcha.value?.execute()
  }, 100)
}

const getParams = parseGetParams();
const showSuccess = ref(false);
const payload = ref<{
  password: string,
  password_confirmation: string,
  token: string,
}>({
  password: '',
  password_confirmation: '',
  token: '',
});

const outerPayload = ref({
  email: null,
  first_name: null,
  last_name: null,
  token: null,
});
const newAccount = computed(()=>
  outerPayload.value.email && 
  outerPayload.value.first_name && 
  outerPayload.value.last_name && 
  outerPayload.value.token
);

const h1 = computed(() => newAccount.value ? 'Set up a new password' : 'Change password');
const subtitle = computed(() => 'Create a new password that is at least 8 characters long and contains numbers, uppercase & lowercase letters');
const loading = ref(false);
const phoneValid = ref();
const form = ref();

onBeforeMount(async () => {
  payload.value.token = getParams.token;
  outerPayload.value.token = getParams.token;
  outerPayload.value.email = getParams.email;
  outerPayload.value.first_name = getParams.first_name;
  outerPayload.value.last_name = getParams.last_name;
  if(localStorage.getItem('access_token')){
    store.dispatch('CmsUserStore/logout').then(() => {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
    })
  }
});

const store = useStore();

const handleSubmit = async () => {
  if(props.captcha_enabled && captcha.value?.captchaStatus !== 'success'){
    captcha.value?.execute()
    return;
  }
  try{
    loading.value = true;
    const data = {
      email: outerPayload.value.email,
      password: payload.value.password,
      password_confirmation: payload.value.password_confirmation,
      token: outerPayload.value.token,
    };
    const result = await store.dispatch('CmsUserStore/newPassword', { payload: data })
    if(result.data?.success === false){
      alert.value?.show(result.data?.message ?? 'Something went wrong')
    } else if (result.data?.success === true) {
      showSuccess.value = true;
    }
  } catch (error : any) {
    alert.value?.show(error)
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    novalidate: "",
    ref_key: "form",
    ref: form,
    class: "form",
    model: payload.value,
    rules: _unref(validationRules)(payload.value.password, phoneValid.value),
    onFinish: handleSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Alert), {
        "show-icon": "",
        class: "alert_absolutly",
        closable: "",
        ref_key: "alert",
        ref: alert
      }, null, 512),
      (_ctx.captcha_enabled)
        ? (_openBlock(), _createBlock(_unref(InvisibleGoogleCaptcha), {
            key: 0,
            ref_key: "captcha",
            ref: captcha,
            onVerify: _cache[0] || (_cache[0] = ($event: any) => {handleSubmit();}),
            onClosed: _cache[1] || (_cache[1] = ($event: any) => {loading.value = false;}),
            onError: _cache[2] || (_cache[2] = ($event: any) => {loading.value = false;}),
            onFail: _cache[3] || (_cache[3] = (msg) => msg === 'loading' ? captchaIsLoading() : loading.value = false)
          }, null, 512))
        : _createCommentVNode("", true),
      _createVNode(NewPasswordOverlays, {
        showSuccess: showSuccess.value,
        loading: loading.value
      }, null, 8, ["showSuccess", "loading"]),
      _createVNode(_unref(LogoTitle), {
        show_logo: _ctx.show_logo,
        title: _ctx.title,
        style: {"margin-bottom":"16px"}
      }, null, 8, ["show_logo", "title"]),
      _createElementVNode("h1", _hoisted_1, _toDisplayString(h1.value), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(subtitle.value), 1),
      (newAccount.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(InputText), {
              name: 'first_name',
              value: outerPayload.value.first_name,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((outerPayload.value.first_name) = $event)),
              onInput: _cache[5] || (_cache[5] = ($event: any) => (form.value.clearValidate())),
              disabled: true,
              placeholder: 'First Name'
            }, null, 8, ["value"]),
            _createVNode(_unref(InputText), {
              name: 'last_name',
              value: outerPayload.value.last_name,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((outerPayload.value.last_name) = $event)),
              onInput: _cache[7] || (_cache[7] = ($event: any) => (form.value.clearValidate())),
              disabled: true,
              placeholder: 'Last Name'
            }, null, 8, ["value"]),
            _createVNode(_unref(EmailInput), {
              name: 'email',
              value: outerPayload.value.email,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((outerPayload.value.email) = $event)),
              onInput: _cache[9] || (_cache[9] = ($event: any) => (form.value.clearValidate())),
              disabled: true
            }, null, 8, ["value"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_unref(PasswordInput), {
        value: payload.value.password,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.password) = $event)),
        onInput: _cache[11] || (_cache[11] = ($event: any) => (form.value.clearValidate()))
      }, null, 8, ["value"]),
      _createVNode(_unref(PasswordInput), {
        name: 'password_confirmation',
        value: payload.value.password_confirmation,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((payload.value.password_confirmation) = $event)),
        onInput: _cache[13] || (_cache[13] = ($event: any) => (form.value.clearValidate())),
        placeholder: 'Confirm Password'
      }, null, 8, ["value"]),
      _createVNode(_unref(Button), {
        block: "",
        html_type: 'submit',
        style: _normalizeStyle(_ctx.support_email ? { marginBottom: '24px'} : {})
      }, {
        default: _withCtx(() => [
          _createTextVNode("Submit")
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_unref(EmailSupportButton), { support_email: _ctx.support_email }, null, 8, ["support_email"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})